const doc = [({"zh_cn":({"adminConstantHotelFacilityType":({"activities":"活动", "camping":"营", "hotel":"酒店"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;